/* eslint-disable */

export default {
  init() {
    // JavaScript to be fired on the Press Center page
    // debounce so filtering doesn't happen every millisecond
    function debounce( fn, threshold ) {
      let timeout;
      return function debounced() {
        if ( timeout ) {
          clearTimeout( timeout );
        }
        function delayed() {
          fn();
          timeout = null;
        }
        timeout = setTimeout( delayed, threshold || 100 );
      };
    }

    // matchHeight.js
    $('.press-tiles__post-content-wrapper').matchHeight({
      byRow: false
    });

    // quick search regex
    let qsRegex;

    const dateYear = $(".press-tiles__post-meta").map(function() {
      return $(this).data("date");
    }).get();

    const dateFormatted = $(".press-tiles__post-meta").map(function() {
      return $(this).text();
    }).get();

    const dateList = {
      'year' : dateYear.sort((a, b) => b-a),
    };

    const dateArray = {
      'formatted' : dateFormatted
    }

    $.each ( dateArray, (key, value) => {
      const dateVal = value;
    });

    function uniq(a) {
      const seen = {};
      return a.filter(item => seen.hasOwnProperty(item) ? false : (seen[item] = true));
    }

    function addItem(newitemnum, newitemdesc) {
       $('#press-tiles__filter-year').append(`<option value="${newitemnum}">${newitemdesc}</option>`);
       $('#press-tiles__filter-year').selectpicker('refresh');
    }

    $.each( dateList, (key, value) => {
      let uniqVal = uniq(value);
      for ( let i = 0, l = uniqVal.length; i < l; i++ ) {
        addItem(`.${key}-${uniqVal[i]}`, uniqVal[i]);
      }
    });

    // init Isotope
    const $grid = $('.press-tiles__grid').isotope({
      itemSelector: '.press-tiles__post',
      layoutMode: 'fitRows',
      initLayout: true,
      getSortData: {
        date(elem) {
          return Date.parse($(elem).find('.press-tiles__post-data-date').text());
        }
      },
      filter() {
        const $this = $(this);
        // first get the value of the topic filter
        const dropdownVal = $('.press-tiles__form-filter').find('option:selected').val();

        // factor the value into the search filter
        const matchedText = dropdownVal ? $this.is( dropdownVal ) : true;

        const searchResult = qsRegex ? $this.text().match( qsRegex ) : true;

        return searchResult && matchedText;
      }
    });

    // use value of search field to filter
    const $quicksearch = $('.quicksearch').keyup( debounce( () => {
      qsRegex = new RegExp( $quicksearch.val(), 'gi' );
      $grid.isotope();
    }, 200 ) );

    //Filter Select
    $('.bootstrap-select').on( 'changed.bs.select', function(event, clickedIndex, newValue, oldValue) {
      // first check the value of the search field
      // grab the value, if any, and include it into the filter
      const filterValue = $(this).find('option').eq(clickedIndex).val();
       $grid.isotope();
     });

     // Remove .selected option from category dropdown
     $('.press-tiles__form-filter').on( 'show.bs.select', function(e) {
       $(this).find('li.selected').addClass('hidden');
     });

     $('.press-tiles__form-filter').on( 'hidden.bs.select', function(e) {
       $(this).find('li.hidden').removeClass('hidden');
     });

     // Remove .selected option from sorting dropdown
     $('.press-tiles__form-sort').on( 'show.bs.select', function(e) {
       $(this).find('li.selected').addClass('hidden');
     });

     $('.press-tiles__form-sort').on( 'hidden.bs.select', function(e) {
       $(this).find('li.hidden').removeClass('hidden');
     });


    //Sort Select
    $('.press-tiles__form-sort').on( 'changed.bs.select', function(event, clickedIndex, newValue, oldValue) {
      const $option = $(this).find('option').eq(clickedIndex);
      let sortValue = $option.val();
      let ascending = true;

      if ( $option.data('ascending') !== undefined ) {
        ascending = $option.data('ascending');
      }

      // make an array of values
      sortValue = sortValue.split(',');

      $grid.isotope({
        sortBy: sortValue,
        sortAscending: ascending
      });
    });

    const $noPosts = $('.press-tiles__form-search').keyup( debounce( () => {
      const numPosts = $grid.data('isotope').filteredItems.length;
      if (numPosts >= 1) {
        $('#msg-box').css({"opacity":"0", "height":"0", "padding":"0"});
      } else {
        $('#msg-box').css({"opacity":"1", "height":"auto", "padding":"60px 0"});
      }

      const userInput = $('.press-tiles__form-search').val();
      $('.press-tiles__no-results--user-input').html(userInput);
    }, 250 ) );

    // Full width container on featured articles
    // $('.featured-articles__container').removeClass('featured-articles__container').addClass('featured-articles__container-fluid');
  },
  finalize() {
    let qsRegex;
    
    // JavaScript to be fired on the Press Center page, after the init JS
    const $grid = $('.press-tiles__grid').isotope({
      itemSelector: '.press-tiles__post',
      layoutMode: 'fitRows',
      initLayout: true,
      getSortData: {
        date(elem) {
          return Date.parse($(elem).find('.press-tiles__post-data-date').text());
        }
      },
      filter() {
        const $this = $(this);
        // first get the value of the topic filter
        const dropdownVal = $('.press-tiles__form-filter').find('option:selected').val();

        // factor the value into the search filter
        const matchedText = dropdownVal ? $this.is( dropdownVal ) : true;

        const searchResult = qsRegex ? $this.text().match( qsRegex ) : true;

        return searchResult && matchedText;
      }
    });

    // bind event
    $grid.isotope( 'on', 'arrangeComplete', () => {
      // matchHeight.js
      $('.product-landing__post-content-wrapper').matchHeight({
        byRow: false
      });
    });
    // manually trigger initial layout
    $grid.isotope();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/pressCenter.js